// extracted by mini-css-extract-plugin
export default {"host":"style_host__LFu7R","handle":"style_handle__C9AwY"};